import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en.json';

/**
 * This app owns its strings rather than borrowing the chat app's catalogue: it ships and
 * deploys on its own, so reaching across into another package's locales would make it
 * unbuildable outside this repo.
 */
export function initI18n(): void {
  if (i18n.isInitialized) {
    return;
  }
  void i18n.use(initReactI18next).init({
    lng: 'en',
    fallbackLng: 'en',
    resources: { en: { translation: en } },
    interpolation: { escapeValue: false },
  });
}
